<template>
    <div class="fixed-bottom d-flex align-items-center justify-content-end w-100">
        <div class="toast-container pb-3 pe-3 bottom-0">
            <div class="toast align-items-center border-0" :class="$page.props.flash.success ? 'show' : ''" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="10000">
                <div class="d-flex border-2 alert alert-success mb-0 p-0">
                    <div class="toast-body">{{ $page.props.flash.success }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>

            <div class="toast align-items-center border-0" :class="$page.props.flash.status ? 'show' : ''" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="10000">
                <div class="d-flex border-2 alert alert-success mb-0 p-0">
                    <div class="toast-body">{{ $page.props.flash.status }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>

            <div class="toast align-items-center border-0" :class="$page.props.flash.warning ? 'show' : ''" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="10000">
                <div class="d-flex border-2 alert alert-warning mb-0 p-0">
                    <div class="toast-body">{{ $page.props.flash.warning }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>

            <div class="toast align-items-center border-0" :class="$page.props.flash.danger ? 'show' : ''" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="10000">
                <div class="d-flex border-2 alert alert-danger mb-0 p-0">
                    <div class="toast-body">{{ $page.props.flash.danger }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>

            <div class="toast align-items-center border-0" :class="$page.props.flash.info ? 'show' : ''" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="10000">
                <div class="d-flex border-2 alert alert-info mb-0 p-0">
                    <div class="toast-body">{{ $page.props.flash.info }}</div>
                    <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
            </div>
        </div>
    </div>
</template>